
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8493_4588)"}},[_c('path',{attrs:{"d":"M9.538 2.358a.256.256 0 00.083-.054c.008-.008.027-.013.051-.013.098 0 .272.075.439.242.106.106.187.23.223.338.025.077.02.126.007.148l-.002.002a61.727 61.727 0 01-.298.3l-.102-.098a13.136 13.136 0 01-.521-.553l-.09-.102.21-.21zM1.545 11.846l-.004.004-.051.051a.144.144 0 00-.03.015.54.54 0 01-.664-.068.53.53 0 01-.069-.662.138.138 0 00.015-.031l6.295-6.296c.036.026.071.05.106.077.024.018.049.036.072.055a5.34 5.34 0 01.612.555c-2.597 2.606-6.282 6.3-6.282 6.3z"}}),_c('path',{attrs:{"d":"M10.676 6.827c-.396.396-.89.639-1.375.678-.19-.705-.599-1.43-1.161-2.053l-.03-.034a6.23 6.23 0 00-.479-.469 5.735 5.735 0 00-.526-.406c-.76-.519-1.587-.805-2.33-.805-.322 0-.618.053-.883.158-.185-.918.206-2.009 1.025-2.828C5.596.39 6.459 0 7.284 0c.083 0 .164.004.245.012.078.657.623 1.63 1.485 2.644a13.391 13.391 0 00.716.776c.051.052.103.102.155.151l.056.053a11.053 11.053 0 001.285 1.077c.302.607.075 1.49-.55 2.114z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8493_4588"}},[_c('path',{attrs:{"d":"M0 0h12v12H0z"}})])])])
          )
        }
      }
    